import React from "react"
import axios from 'axios'
import $ from "jquery";
import { MDCList } from '@material/list';
import { MDCRipple } from '@material/ripple';
import { MDCTextField } from '@material/textfield';
import { MDCTabBar } from '@material/tab-bar';
import Slider from '@material-ui/core/Slider';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Snackbar from '@material-ui/core/Snackbar';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const defaultBtnLabel = <div><i className="fas fa-search" aria-hidden="true" style={{ marginRight: "6px" }}></i> Найти за 3$</div>
const waitingBtnLabel = <CircularProgress classes={{ root: "tmbtn" }} />

class TeleSearchPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      link: "",
      time: 0,
      days: 5,
      views: 0.34,
      total: 2,
      day_price: 28,
      error: null,
      isLoaded: false,
      items: [],
      selected: {},
      open: false,
      btn_label: defaultBtnLabel
    }
  }


  snackbarOpen = (message) => {
    this.setState({ open: true, message })
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') return
    this.setState({ open: false })
  }

  setSelected(selected) {
     return this.setState({ selected })
  }

  handleClick = (event) => {
   
    if(this.state.link.length < 5) return this.snackbarOpen('Введите ссылку на канал')
    if(this.state.views < 100) return this.snackbarOpen('Минимальное кол-во просмотров - 100')
    if(this.state.views > 10000) return this.snackbarOpen('Максимальное кол-во просмотров - 10000')

    if(this.state.time < 0) return this.snackbarOpen('Минимальное время накрутки - 0 часов')
    if(this.state.time > 200) return this.snackbarOpen('Максимальное время накрутки - 200 часов')

    if(this.state.days < 5) return this.snackbarOpen('Минимальная продолжительность накрутки - 5 дней')
    if(this.state.days > 365) return this.snackbarOpen('Максимальная продолжительность накрутки - 365 дней')

    axios.post("https://nakrutkatop.com:443/api/tv/order", { 

      link: this.state.link, 
      views: this.state.views,
      days: this.state.days,
      time: this.state.time,

    },{ withCredentials: true })
      .then(res => {
        this.snackbarOpen(res.data.descr)
        this.props.updateBalance()
      })
  }

/*
  loadHistory() {
    axios.get("https://nakrutkatop.com:443/api/ts/history", { withCredentials: true }).then(res => {res.data.ok && this.setState({isLoaded: true, items: res.data.history})})
  } 

  componentDidMount() {

  }
*/
  render(props) {
    return <div className="mdc-drawer-app-content mdc-top-app-bar--fixed-adjust icontent" >
      <div className="page_wrap" ng-view style={{ maxWidth: "0px", maxHeight: "0px", opacity: 0, display: "none" }}></div>
      <div id="notify_sound"></div>

      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={this.state.open}
        autoHideDuration={6000}
        onClose={this.handleClose}
        message={this.state.message}
        action={
          <React.Fragment>
            <Button color="secondary" size="small" onClick={this.handleClose}>
              Закрыть
            </Button>

          </React.Fragment>
        }
      />
      <main className="main-content custom-scrollbar" id="main-content">

        <h2 className="pageHeader"> <i className="fas fa-eye mdc-list-item__graphic fa-lg" aria-hidden="true" style={{ color: "#fff", marginRight: "40px" }}></i>Автопросмотры Telegram</h2>

        <div className="irow center-align-row" style={{ display: "flex", flexWrap: "wrap", paddingTop: "16px" }}>
          <div className="ibox" style={{ width: "600px", flex: "0 0 600px", maxWidth: "100%", opacity: "1", margin: "8px", transition: ".3s opacity, .3s visibility" }} id="tasksBox">
            <h3 className="ibox_title"><div><i class="fas fa-info" aria-hidden="true" style={{ marginRight: "8px" }}></i> Информация</div>  <div>
            </div></h3>
            <div className="ibox_content full-height acc-status-table" style={{ padding: "16px", paddingTop: "0px", marginLeft: "0px", display: 'block' }}>
            <i class="fas fa-eye" aria-hidden="true" style={{ marginRight: "8px" }}></i>Автопросмотры - функция, которая накручивает просмотры на новые посты любого канала в автоматическом режиме<br></br><br></br>

            <i class="fas fa-eye-slash" aria-hidden="true" style={{ marginRight: "8px" }}></i>Данные просмотры скрытые и нигде не отображаются (полная анонимность)<br></br><br></br>
                
            <i class="fas fa-pen" aria-hidden="true" style={{ marginRight: "8px" }}></i>Количество просмотров и скорость накрутки устанавливается при покупке тарифа
             
                </div>
          </div>


          <div className="ibox" style={{ width: "600px", flex: "0 0 600px", maxWidth: "100%", opacity: "1", margin: "8px", transition: ".3s opacity, .3s visibility" }} id="tasksBox">
            <h3 className="ibox_title"><div><i class="fas fa-search" aria-hidden="true" style={{ marginRight: "8px" }}></i> Заказ</div>  <div>
            </div></h3>
            <div className="ibox_content full-height" style={{ padding: "8px", display: "inline-block" }}>
              <FormControl variant="outlined" classes={{ root: "full" }}>
                <InputLabel htmlFor="outlined-basic">Ссылка на канал</InputLabel>
                <OutlinedInput id="outlined-basic" label="Ссылка на канал" variant="outlined" value={this.state.link} onChange={(event) => this.setState({ link: event.target.value })} />
              </FormControl>

              <FormControl variant="outlined" classes={{ root: "ltb half" }}>
                <InputLabel htmlFor="outlined-basic">Количество</InputLabel>
                <OutlinedInput id="outlined-basic" type='number' label="Количество" variant="outlined" value={this.state.views} endAdornment={<InputAdornment position="end"> <i class="fas fa-eye" aria-hidden="true" style={{color: '#fff'}}></i></InputAdornment>} onChange={(event) => this.setState({ views: event.target.value, day_price: calcPrice( event.target.value), total: Math.ceil(calcPrice( event.target.value) * this.state.days)})} />
              </FormControl>
  
              <FormControl variant="outlined" classes={{ root: "rtb half" }}>
                <InputLabel htmlFor="outlined-basic">Стоимость дня</InputLabel>
                <OutlinedInput id="outlined-basic" label="Стоимость дня" variant="outlined" value={this.state.day_price}  endAdornment={<InputAdornment position="end">$</InputAdornment>} inputProps={{ readOnly: true }}/>
              </FormControl>

              <FormControl variant="outlined" classes={{ root: "ltb half" }}>
                <InputLabel htmlFor="outlined-basic">Время накрутки</InputLabel>
                <OutlinedInput id="outlined-basic" type='number' label="Время накрутки" variant="outlined" value={this.state.time} onChange={(event) => this.setState({ time: event.target.value })} endAdornment={<InputAdornment position="end">часов</InputAdornment>}/>
              </FormControl>

              <FormControl variant="outlined" classes={{ root: "rtb half" }}>
                <InputLabel htmlFor="outlined-basic">Продолжительность</InputLabel>
                <OutlinedInput id="outlined-basic" type='number' label="Продолжительность" variant="outlined" value={this.state.days} onChange={(event) => this.setState({ days: event.target.value, total: Math.ceil(this.state.day_price * event.target.value) })} endAdornment={<InputAdornment position="end">дней</InputAdornment>}/>
              </FormControl>

              <FormControl variant="outlined" classes={{ root: "rtb half" }}>
                <InputLabel htmlFor="outlined-basic">Итого</InputLabel>
                <OutlinedInput id="outlined-basic" type='number' label="Итого" variant="outlined" value={this.state.total} endAdornment={<InputAdornment position="end">$</InputAdornment>} inputProps={{ readOnly: true }}/>
              </FormControl>

              <Button variant="contained" onClick={this.handleClick} classes={{ root: "rtb half order-btn" }} style={{ height: "54px" }}><i class="fas fa-shopping-cart" aria-hidden="true" style={{color: '#fff', marginRight: '8px'}}></i> Заказать</Button>
              
            </div>
          </div>

        </div>
      </main>
    </div>
  }
}
//   <SIMRentParams state={this.state} />
export default TeleSearchPage

const calcPrice = (views) => Number(((25 + views / 333.33) / 83).toFixed(2))
